import Loadable from '../../components/loadable';

const ContactDataSeries = Loadable({
  loader: () => import('../../pages/contacts/data_series'),
  type: 'block',
});

const DataSeriesManageMetricsModal = Loadable({
  loader: () => import('../../pages/contacts/data_series/manage_metrics_modal'),
  type: 'modal',
});

const DataSeriesSendEmailModal = Loadable({
  loader: () => import('../../pages/contacts/data_series/send_email_modal'),
  type: 'modal',
});

angular.module('gym').value('ContactDataSeries', ContactDataSeries);
angular.module('gym').value('DataSeriesManageMetricsModal', DataSeriesManageMetricsModal);
angular.module('gym').value('DataSeriesSendEmailModal', DataSeriesSendEmailModal);
